import { ISurvey } from '@konova/api-types';
import { createContext, FC, PropsWithChildren, useContext } from 'react';

export type MutateSurveyFn = (survey: Partial<ISurvey> | null) => void;

export type SurveyContextValue = {
  survey: ISurvey | null;
  isAdmin: boolean;
  mutate: MutateSurveyFn;
};

const SurveyContext = createContext<SurveyContextValue>({
  survey: null,
  isAdmin: false,
  mutate() {
    throw new Error('mutate function not implemented');
  },
});

export const useSurveyContext = () => useContext(SurveyContext);

export const SurveyContextProvider: FC<PropsWithChildren & { survey: ISurvey | null; onUpdate: MutateSurveyFn }> = ({ children, survey, onUpdate }) => {

  return <SurveyContext.Provider value={{
    survey,
    isAdmin: survey?.userRole === 'admin',
    mutate: onUpdate
  }}>
    {children}
  </SurveyContext.Provider>;
};